import { useEffect, useRef } from "react";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

export default function MentionsLegales() {
  const topRef = useRef(null);

  useEffect(() => {
    // Scroll to the element with the ref attached
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  return (
    <>
      <div ref={topRef}></div>
      <TopNavbar />
      <div className="mt-24 md:mt-28"></div>
      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold mb-6 text-center">
          Mentions Légales
        </h1>
        <div className="space-y-4 text-gray-700 text-base">
          <div>
            <span className="font-semibold">Propriétaire:</span>
            <br />
            SAS VAL ACADEMY INTERNATIONAL
            <br />2 Avenue Lenine, 93230 Romainville
          </div>
          <div>
            <span className="font-semibold">Responsable publication:</span>
            <br />
            SCHECROUN Valerie - 01 62 37 02 62
          </div>
          <div>
            <span className="font-semibold">Webmaster:</span>
            <br />
            SCHECROUN Valerie - 01 62 37 02 62
            <br />
            BEJAOUI AYMEN aymen.bejaoui1997@gmail.com
          </div>
          <div>
            <span className="font-semibold">Hébergeur:</span>
            <br />
            IONOS SARL
            <br />
            7, place de la Gare BP 70109 57200 Sarreguemines Cedex France
          </div>
          <div>
            <span className="font-semibold">
              Délégué à la protection des données:
            </span>
            <br />
            SCHECROUN Valerie -{" "}
            <a
              href="mailto:contact@valacademyformation.com"
              className="text-blue-600 hover:underline"
            >
              contact@valacademyformation.com
            </a>
          </div>
        </div>
      </div>
      <div style={{ marginBottom: "2.0%" }}></div>
      <Footer />
    </>
  );
}
